import { render, staticRenderFns } from "./ReplacePurchaseItem.vue?vue&type=template&id=948c5040&scoped=true"
import script from "./ReplacePurchaseItem.vue?vue&type=script&lang=js"
export * from "./ReplacePurchaseItem.vue?vue&type=script&lang=js"
import style0 from "./ReplacePurchaseItem.vue?vue&type=style&index=0&id=948c5040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948c5040",
  null
  
)

export default component.exports